// extracted by mini-css-extract-plugin
export var activeDot = "_97-c";
export var buttonContainer = "_97-9";
export var channelButton = "_97-a";
export var clickable = "_97-d";
export var content = "_97-0";
export var contentFull = "_97-2";
export var contentThird = "_97-1";
export var contentWrapper = "_97-7";
export var description = "_97-5";
export var heightShort = "_97-f";
export var image = "_97-3";
export var imageContainer = "_97-4";
export var selectButton = "_97-e";
export var spinnerContainer = "_97-b";
export var titleContent = "_97-8";
export var titleWrapper = "_97-6";